/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamOfTheWeekLineupPositionPlayer = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        player: {
            type: 'PlayerMedium',
            isRequired: true,
        },
        position: {
            type: 'LineupPosition',
            isRequired: true,
        },
    },
} as const;
